<div class="gpd-container gpd-full-page">
  <div class="gpd-container-header">
    <div></div>
    <div class="action-buttons">
      <app-gpd-button
        (onClick)="showOverview()"
        type="secondary"
        i18n-text="@@showCompleteOverview"
        text="Show Complete Overview"
      ></app-gpd-button>
    </div>
  </div>
  <div class="gpd-container-header">
    <div class="select-box-container">
      <dx-select-box
        [dataSource]="projectConfiguration"
        class="config-select-box"
        displayExpr="title"
        valueExpr="id"
        [(value)]="selectedPhaseValue"
        (onValueChanged)="selectPhase($event)"
      >
      </dx-select-box>
      <dx-select-box
        [dataSource]="$safeNavigationMigration(selectedPhase?.milestones)"
        class="config-select-box"
        displayExpr="name"
        valueExpr="id"
        [(value)]="selectedMilestoneValue"
        (onValueChanged)="selectMilestone($event)"
      >
      </dx-select-box>
      <dx-select-box
        [dataSource]="$safeNavigationMigration(selectedMilestone?.taskPackages)"
        class="config-select-box"
        displayExpr="name"
        valueExpr="id"
        [(value)]="selectedTaskPackageValue"
        (onValueChanged)="selectTaskPackage($event)"
      ></dx-select-box>
    </div>
  </div>
  <div class="gpd-container-header">
    <div class="action-buttons">
      <span class="task-count">Tasks: {{ taskCount }} </span>
      <span class="group-count">Groups: {{ groupCount }} </span>
    </div>
    <div class="gpd-button-group">
      <app-gpd-button
        (onClick)="moveTasks()"
        icon="add"
        type="secondary"
        [disabled]="editingData || selectedTasks.length == 0"
        i18n-text="@@moveTasks"
        text="Move Tasks"
      ></app-gpd-button>
      <app-gpd-button
        (onClick)="addGroup()"
        icon="add"
        type="secondary"
        [disabled]="editingData"
        i18n-text="@@addGroup"
        text="Add Group"
      ></app-gpd-button>
      <app-gpd-button
        (onClick)="addTask()"
        icon="add"
        [disabled]="editingData"
        i18n-text="@@addTask"
        text="Add Task"
      ></app-gpd-button>
    </div>
  </div>
  <app-template-apply-banner></app-template-apply-banner>
  <dx-scroll-view #scrollView class="task-scroll-view">
    @if (!selectedTaskPackageValue && !isLoading) {
      <div class="no-selection-message">
        <div class="message-content">
          <h3 i18n="@@noTaskPackageSelected">No Task Package Selected</h3>
          <p i18n="@@selectTaskPackageMessage">
            Please select a phase, milestone, and task package from the dropdowns above to view and manage tasks.
          </p>
          <app-gpd-button
            (onClick)="showOverview()"
            type="primary"
            i18n-text="@@backToOverview"
            text="Back to Overview"
          ></app-gpd-button>
        </div>
      </div>
    } @else if (tasksTree.length === 0 && !isLoading) {
      <div class="no-tasks-message">
        <div class="message-content">
          <h3 i18n="@@noTasksAvailable">No tasks available for this task package</h3>
          <p i18n="@@noTasksMessage">
            This task package doesn't have any tasks yet. You can add new tasks or groups using the buttons above.
          </p>
        </div>
      </div>
    } @else {
      <dx-sortable
        class="overview-items"
        [data]="tasksTree"
        [allowReordering]="true"
        handle=".drag-handle"
        (onReorder)="onReorder($event)"
        (onDragStart)="startReorder($event)"
        (onAdd)="onReorder($event)"
        (onDragChange)="onDragMove($event)"
        dragTemplate="drag-template"
        group="tasks"
        [allowDropInsideItem]="true"
        [attr.parentId]="null"
      >
        <div *dxTemplate="let item of 'drag-template'" class="drag-template">
          <div
            [innerHTML]="item.itemElement.outerHTML | safeHTML"
            [style.width.px]="item.itemElement.scrollWidth"
          ></div>
        </div>

        @for (task of tasksTree; track task.id; let taskIndex = $index) {
          <div class="task-tree-item">
            <app-config-task-node
              [task]="task"
              [itemNumber]="taskIndex + 1"
              (onStartEdit)="onStartEdit(task)"
              (onCancel)="cancelTaskEdit($event)"
              (onSave)="SavingTask($event)"
              (onDelete)="deleteTask(task)"
              [allowEdit]="!editingData"
              [allowDelete]="!editingData"
              (onAddTask)="addTask($event)"
              [projectConfiguration]="configurationTree"
              (onClick)="onTaskClick(task)"
              [selected]="selectedTasks.includes(task.id)"
              [allTasks]="allTasks"
              [archived]="task.archived"
              (onArchive)="onArchive(task)"
              (onReactivate)="onReactivate(task)"
            ></app-config-task-node>

            @if (task.children?.length > 0 && task.expanded == true) {
              <div class="task-children" [class.task-children-group]="task.type === 'group'">
                <dx-sortable
                  [allowReordering]="true"
                  class="overview-items"
                  [data]="task.children"
                  handle=".drag-handle"
                  dropFeedbackMode="indicate"
                  (onReorder)="onReorder($event)"
                  (onDragStart)="startReorder($event)"
                  (onAdd)="onReorder($event)"
                  (onDragChange)="onDragMove($event)"
                  dragTemplate="child-drag-template"
                  group="tasks"
                  [attr.parentId]="task.id"
                >
                  <div *dxTemplate="let item of 'child-drag-template'" class="drag-template">
                    <div
                      [innerHTML]="item.itemElement.outerHTML | safeHTML"
                      [style.width.px]="item.itemElement.scrollWidth"
                    ></div>
                  </div>

                  @for (childTask of task.children; track childTask.id; let childIndex = $index) {
                    <div class="task-tree-item">
                      <app-config-task-node
                        [task]="childTask"
                        [itemNumber]="childIndex + 1"
                        (onStartEdit)="onStartEdit(childTask)"
                        (onCancel)="cancelTaskEdit($event)"
                        (onSave)="SavingTask($event)"
                        (onDelete)="deleteTask(childTask)"
                        [allowEdit]="!editingData"
                        [allowDelete]="!editingData"
                        [projectConfiguration]="configurationTree"
                        (onClick)="onTaskClick(childTask)"
                        [selected]="selectedTasks.includes(childTask.id)"
                        [allTasks]="allTasks"
                        [archived]="childTask.archived"
                        (onArchive)="onArchive(childTask)"
                        (onReactivate)="onReactivate(childTask)"
                      ></app-config-task-node>
                    </div>
                  }
                </dx-sortable>
              </div>
            }
          </div>
        }
      </dx-sortable>
    }
  </dx-scroll-view>
</div>

<dx-popup
  [width]="478"
  height="fit-content"
  [(visible)]="showConfirmationPopup"
  i18n-title="@@selectOption"
  title="Select Option"
  [showTitle]="true"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [wrapperAttr]="{ class: 'gpd-popup' }"
>
  <div class="confirmation-popup-content">
    <p class="confirmation-intro" i18n="@@selectHowTaskAdded">
      Choose how the task will be added to existing projects.
    </p>

    <div class="option-cards">
      <div class="option-card">
        <div class="option-card-text">
          <div class="option-card-title" i18n="@@save">Save</div>
          <div class="option-card-body">
            <span i18n="@@taskWillBeAddedAs">The task will be added as </span><strong i18n="@@open">open</strong
            ><span i18n="@@inAllProjects"> in all projects.</span>
          </div>
        </div>
        <div class="option-banner warning-banner">
          <app-svg-icon icon="alert" color="#f4b400"></app-svg-icon>
          <span i18n="@@completedMilestonesWarning
          ">Already completed milestones may reopen as a result.</span>
        </div>
      </div>

      <div class="option-card ">
        <div class="option-card-text">
          <div class="option-card-title" i18n="@@selectProjects">Select Projects</div>
          <div class="option-card-body">
            <span i18n="@@forSelectedProjectsTask">For selected projects, the task will be marked as </span
            ><strong i18n="@@notRequired">not required.</strong>
          </div>
        </div>
        <div class="option-banner success-banner">
          <app-svg-icon icon="checkmark-circle" color="#16a34a"></app-svg-icon>
          <span i18n="@@completedProjectsUnaffected">Completed and Canceled projects remain unaffected.</span>
        </div>
      </div>
    </div>
    <div class="confirmation-footer">
      <app-gpd-button
        i18n-text="@@selectProjects"
        text="Select Projects"
        type="secondary"
        (onClick)="showProjectList()"
      ></app-gpd-button>
      <app-gpd-button i18n-text="@@save" text="Save" (onClick)="saveTask(this.savedEvent)"></app-gpd-button>
    </div>
  </div>
</dx-popup>

<!-- popup to choose projects when creating a task  -->
<dx-popup
  [(visible)]="showProjects"
  i18n-title="@@chooseProject"
  title="Choose Projects"
  class="projects-pop"
  [wrapperAttr]="{ class: 'gpd-popup' }"
>
  <div class="project-selection-container">
    <dx-data-grid
      #grid
      class="gpd-datagrid project-list"
      [dataSource]="projectList"
      [remoteOperations]="false"
      [selectedRowKeys]="selectedProjects"
      [rowAlternationEnabled]="true"
      [wordWrapEnabled]="true"
      showScrollbar="always"
      height="100%"
      [allowColumnResizing]="true"
      columnResizingMode="widget"
      [columnAutoWidth]="false"
      [showBorders]="true"
      [hoverStateEnabled]="true"
      keyExpr="id"
      (onRowClick)="onRowClick($event)"
      (onContentReady)="onGridContentReady()"
    >
      <dxo-selection
        mode="multiple"
        [showCheckBoxesMode]="'none'"
        [selectByClick]="false"
        [allowSelectAll]="true"
      ></dxo-selection>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>

      <dxi-column
        [showEditorAlways]="true"
        editCellTemplate="selectedTemplate"
        dataField="selected"
        caption="Selected"
        [width]="50"
        cssClass="center-checkbox-column"
        headerCellTemplate="headerTemplate"
        [allowFiltering]="false"
        [allowSorting]="false"
      >
        <div *dxTemplate="let info of 'headerTemplate'">
          <dx-check-box
            *ngIf="!isFilterActive"
            [(value)]="isAllSelected"
            (valueChange)="selectAll($event)"
            class="custom-header-checkbox"
          >
          </dx-check-box>
        </div>

        <div *dxTemplate="let item of 'selectedTemplate'">
          <dx-check-box [value]="isProjectSelected(item.data.id)" [disabled]="true" class="custom-disabled-checkbox">
          </dx-check-box>
        </div>
      </dxi-column>

      <dxi-column
        i18n-caption="@@projectNr"
        dataField="projectNr"
        caption="Project Number"
        [width]="140"
        [allowFiltering]="true"
        [allowHeaderFiltering]="false"
      ></dxi-column>
      <dxi-column i18n-caption="@@name" dataField="name" [allowFiltering]="true"></dxi-column>
      <dxi-column i18n-caption="@@areaType" dataField="areaType" caption="Area Type" [allowFiltering]="true">
        <dxo-lookup [dataSource]="areaTypeList" valueExpr="id" displayExpr="name"></dxo-lookup>
      </dxi-column>
      <dxi-column i18n-caption="@@status" dataField="status" caption="Status" [allowFiltering]="true"> </dxi-column>
    </dx-data-grid>

    <div class="popup-footer">
      <app-gpd-button
        i18n-text="@@cancel"
        text="Cancel"
        type="secondary"
        (onClick)="showProjects = false"
      ></app-gpd-button>
      <app-gpd-button
        i18n-text="@@confirm"
        text="Confirm"
        (onClick)="saveUpdates()"
      ></app-gpd-button>
    </div>
  </div>
</dx-popup>

<!-- Archive confirmation popup -->
<app-generic-popup
  [(visible)]="archivePopupVisible"
  i18n-title="@@archiveTask"
  title="Archive task"
  [allowOutsideClick]="false"
  [width]="480"
  [buttons]="[
    { text: cancelLabel, type: 'secondary', onClick: cancelArchive.bind(this), disabled: archiveInProgress },
    { text: archiveConfirmLabel, type: 'primary', onClick: confirmArchive.bind(this), disabled: archiveInProgress, closeOnClick: false }
  ]"
>
  <p class="gpd-popup-confirm-question archive-lead" i18n="@@archiveTaskQuestion">The task <strong>{{ taskPendingArchive?.title }}</strong> will be archived and will no longer be available for new projects.</p>
  <app-validation-toast
    state="Warning"
    [inline]="true"
    i18n-autoMessage="@@archiveTaskWarning"
    autoMessage="Linked condition rules will be permanently deleted. This action cannot be undone."
  ></app-validation-toast>
  @if (archiveOpenTaskCount > 0) {
    <div class="archive-secondary-action">
      <dx-check-box
        class="gpd-input archive-not-required-option"
        [(value)]="archiveSetNotRequired"
        [text]="archiveNotRequiredLabel"
        [disabled]="archiveInProgress"
      ></dx-check-box>
      <p class="gpd-popup-info-note archive-hint" i18n="@@archiveTaskNotRequiredHint">Only applies to open tasks. Tasks with the status "In progress", "In review", "Rejected" or "Done", as well as completed and cancelled projects, remain unchanged.</p>
      @if (archiveSetNotRequired) {
        <app-validation-toast
          class="archive-nested-warning"
          state="Warning"
          [inline]="true"
          i18n-autoMessage="@@archiveNotRequiredConsequences"
          autoMessage="Completing these tasks may complete their task packages. Planned start and due dates of those packages are then set to the completion date and their scheduling dependencies are removed. This cannot be undone."
        ></app-validation-toast>
      }
    </div>
  } @else {
    <p class="gpd-popup-info-note" i18n="@@archiveTaskInfo">Existing projects are not affected.</p>
  }
  @if (archiveImpactTasks.length > 0) {
    <p i18n="@@archiveImpactDescription">The following tasks have condition rules that will be updated:</p>
    <ul>
      @for (t of archiveImpactTasks; track t.taskId) {
        <li>{{ t.taskTitle }}</li>
      }
    </ul>
  }
</app-generic-popup>

<!-- Reactivate confirmation popup -->
<app-generic-popup
  [(visible)]="reactivatePopupVisible"
  i18n-title="@@reactivateTask"
  title="Aufgabe reaktivieren"
  [allowOutsideClick]="false"
  [width]="480"
  [buttons]="[
    { text: 'Abbrechen', type: 'secondary', onClick: cancelReactivate.bind(this) },
    { text: 'Reaktivieren', type: 'primary', onClick: confirmReactivate.bind(this) }
  ]"
>
  <p i18n="@@reactivateTaskDescription1">Diese Aufgabe steht neuen Projekten wieder zur Verfügung.</p>
  <p i18n="@@reactivateTaskDescription2">Bedingungsregeln, die diese Aufgabe referenziert haben, wurden beim Archivieren entfernt und können nicht automatisch wiederhergestellt werden.</p>
  <p i18n="@@reactivateTaskDescription3">Projekte, die während der Archivierung dieser Aufgabe erstellt wurden, erhalten diese Aufgabe nicht.</p>
</app-generic-popup>

<!-- Delete confirmation popup -->
<app-generic-popup
  [(visible)]="deletePopupVisible"
  [title]="deletePopupTitle"
  [allowOutsideClick]="false"
  [width]="480"
  [buttons]="[
    { text: cancelLabel, type: 'tertiary-text', onClick: cancelDelete.bind(this) },
    { text: deleteLabel, type: 'danger', onClick: confirmDelete.bind(this) }
  ]"
>
  @if (taskPendingDelete?.type === 'group') {
    <p i18n="@@deleteGroupConfirmation">Are you sure you want to delete the group <strong>{{ taskPendingDelete?.title }}</strong>? This action cannot be undone.</p>
  } @else {
    <p i18n="@@deleteTaskConfirmation">Are you sure you want to delete the task <strong>{{ taskPendingDelete?.title }}</strong>? This action cannot be undone.</p>
  }
  @if (taskPendingDelete?.type === 'group') {
    <div style="margin-top: 12px">
      <app-validation-toast
        state="Warning"
        [inline]="true"
        [autoMessage]="deleteGroupWarningMessage"
      ></app-validation-toast>
    </div>
  }
  @if (taskPendingDelete && taskPendingDelete.type !== 'group') {
    <div style="margin-top: 12px">
      <app-validation-toast
        state="Warning"
        [inline]="true"
        [autoTitle]="deleteTaskWarningTitle"
        [htmlMessage]="deleteTaskWarningHtml"
      ></app-validation-toast>
    </div>
  }
</app-generic-popup>

<app-generic-popup
  [visible]="showMoveTasks"
  i18n-title="@@moveTasks"
  title="Move Tasks"
  [allowOutsideClick]="false"
  [width]="440"
>
  <div class="reopen-reason-content" *ngIf="showMoveTasks">
    <p i18n="@@moveTasksDescription">Select the phase, milestone, and task package to move the selected tasks to.</p>

    <div class="move-tasks-field">
      <label class="move-tasks-label" i18n="@@phase">Phase</label>
      <dx-select-box
        class="gpd-input"
        [(value)]="showMoveTasks.phaseId"
        [dataSource]="projectConfiguration"
        displayExpr="title"
        valueExpr="id"
        [searchEnabled]="true"
      >
        <dx-validator> <dxi-validation-rule type="required"></dxi-validation-rule> </dx-validator>
      </dx-select-box>
    </div>

    <div class="move-tasks-field">
      <label class="move-tasks-label" i18n="@@milestone">Milestone</label>
      <dx-select-box
        class="gpd-input"
        [(value)]="showMoveTasks.milestoneId"
        [dataSource]="getFilteredMilestones(showMoveTasks.phaseId)"
        displayExpr="name"
        valueExpr="id"
        [searchEnabled]="true"
      >
        <dx-validator> <dxi-validation-rule type="required"></dxi-validation-rule> </dx-validator>
      </dx-select-box>
    </div>

    <div class="move-tasks-field">
      <label class="move-tasks-label" i18n="@@taskPackage">Task Package</label>
      <dx-select-box
        class="gpd-input"
        [(value)]="showMoveTasks.taskPackageId"
        [dataSource]="getFilteredTaskPackages(showMoveTasks.phaseId, showMoveTasks.milestoneId)"
        displayExpr="name"
        valueExpr="id"
        [searchEnabled]="true"
      >
        <dx-validator> <dxi-validation-rule type="required"></dxi-validation-rule> </dx-validator>
      </dx-select-box>
    </div>
  </div>
  <div popup-actions class="action-container">
    <app-gpd-button
      type="secondary"
      i18n-text="@@cancel"
      text="Cancel"
      (onClick)="showMoveTasks = null"
    ></app-gpd-button>
    <app-gpd-button
      type="primary"
      i18n-text="@@save"
      text="Save"
      (onClick)="$event.validationGroup.validate().isValid && onConfirmMoveTasks()"
    ></app-gpd-button>
  </div>
</app-generic-popup>

<!-- Site task confirmation popup -->
<dx-popup
  [width]="478"
  height="fit-content"
  [(visible)]="showSiteConfirmationPopup"
  i18n-title="@@selectOption"
  title="Select Option"
  [showTitle]="true"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [wrapperAttr]="{ class: 'gpd-popup' }"
>
  <div class="confirmation-popup-content">
    <p class="confirmation-intro" i18n="@@selectHowSiteTaskAdded">
      Choose how the task will be added to existing locations.
    </p>

    <div class="option-cards">
      <div class="option-card" >
        <div class="option-card-text">
          <div class="option-card-title" i18n="@@save">Save</div>
          <div class="option-card-body">
            <span i18n="@@siteTaskWillBeCreatedAs">The task will be created as </span><strong i18n="@@open">open</strong><span i18n="@@inAllProjectsOfEachSite"> in all projects of each site.</span>
          </div>
        </div>
        <div class="option-banner warning-banner">
          <app-svg-icon icon="alert" color="#f4b400"></app-svg-icon>
          <span i18n="@@completedMilestonesWarning">Already completed milestones may reopen as a result.</span>
        </div>
      </div>

      <div class="option-card">
        <div class="option-card-text">
          <div class="option-card-title" i18n="@@selectSites">Select Sites</div>
          <div class="option-card-body">
            <span i18n="@@forSelectedSitesTask">For selected sites, the task is marked as </span><strong i18n="@@notRequired">not required.</strong>
          </div>
        </div>
        <div class="option-banner success-banner">
          <app-svg-icon icon="checkmark-circle" color="#16a34a"></app-svg-icon>
          <span i18n="@@completedAndCancelledProjectsUnaffected">Completed and cancelled projects remain unaffected.</span>
        </div>
      </div>
    </div>
    <div class="confirmation-footer">
      <app-gpd-button
        i18n-text="@@selectSites"
        text="Select Sites"
        type="secondary"
        (onClick)="showSiteList()"
      ></app-gpd-button>
      <app-gpd-button
        i18n-text="@@save"
        text="Save"
        (onClick)="saveTask(this.savedEvent)"
      ></app-gpd-button>
    </div>
  </div>
</dx-popup>

<!-- popup to choose sites when creating a site task -->
<dx-popup
  [(visible)]="showSites"
  i18n-title="@@chooseSites"
  title="Choose Sites"
  class="projects-pop"
  [wrapperAttr]="{ class: 'gpd-popup' }"
>
  <div class="project-selection-container">
    <dx-data-grid
      #siteGrid
      class="gpd-datagrid"
      [dataSource]="siteList"
      [remoteOperations]="false"
      [selectedRowKeys]="selectedSites"
      [rowAlternationEnabled]="true"
      [wordWrapEnabled]="true"
      showScrollbar="always"
      height="100%"
      [allowColumnResizing]="true"
      columnResizingMode="widget"
      [columnAutoWidth]="false"
      [showBorders]="true"
      [hoverStateEnabled]="true"
      keyExpr="id"
      (onRowClick)="onSiteRowClick($event)"
    >
      <dxo-selection
        mode="multiple"
        [showCheckBoxesMode]="'none'"
        [selectByClick]="false"
        [allowSelectAll]="true"
      ></dxo-selection>

      <dxi-column
        [showEditorAlways]="true"
        editCellTemplate="siteSelectedTemplate"
        dataField="selected"
        [width]="50"
        cssClass="center-checkbox-column"
        headerCellTemplate="siteHeaderTemplate"
        [allowSorting]="false"
      >
        <div *dxTemplate="let info of 'siteHeaderTemplate'">
          <dx-check-box [(value)]="isAllSitesSelected" (valueChange)="selectAllSites($event)" class="custom-header-checkbox"></dx-check-box>
        </div>
        <div *dxTemplate="let item of 'siteSelectedTemplate'">
          <dx-check-box [value]="isSiteSelected(item.data.id)" [disabled]="true" class="custom-disabled-checkbox"></dx-check-box>
        </div>
      </dxi-column>

      <dxi-column i18n-caption="@@nr" dataField="nr" caption="Nr" [width]="100"></dxi-column>
      <dxi-column i18n-caption="@@name" dataField="name"></dxi-column>
    </dx-data-grid>

    <div class="popup-footer">
      <app-gpd-button
        i18n-text="@@cancel"
        text="Cancel"
        type="secondary"
        (onClick)="showSites = false"
      ></app-gpd-button>
      <app-gpd-button
        i18n-text="@@confirm"
        text="Confirm"
        (onClick)="saveSiteUpdates()"
      ></app-gpd-button>
    </div>
  </div>
</dx-popup>
